export class ApiConstants {
  public static ALERT_TYPE_FAILURE = 'danger';
  public static MSG_LOGOUT_FAILURE =
    'Error: Unable to logout session. Contact the Help Desk.';
  public static SESSION_EXIST = 'SESSION_EXISTS';
}
